const DISPLAY_NAME: Record<string, string> = {
  api: 'API',
  github: 'GitHub',
  gitlab: 'GitLab',
};
const EDIT_TEXT: Record<string, string> = {
  github: 'Edit on GitHub',
  gitlab: 'Edit on GitLab',
};

export const externalDisplayName = (platform: string) =>
  DISPLAY_NAME[platform] || 'External';
export const externalEditText = (platform: string) =>
  EDIT_TEXT[platform] || 'Edit source';
